<template>
  <v-app class="futuristic-app">

    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" />
          </div>

          <div class="brand-copy">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <div class="header-info d-none d-sm-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74"> mdi-map-clock </v-icon>
          </div>

          <div>
            <div class="header-info-title">Info Lalu Lintas</div>
            <div class="header-info-subtitle">Pengalihan arus terkini</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container
        class="mt-6 mx-auto content-layer"
        style="max-width: 1200px; position: relative; z-index: 5"
      >
        <div class="mobile-view-switch d-lg-none mb-3">
          <v-btn
            class="switch-btn"
            :class="{ 'switch-btn-active': mobileView === 'list' }"
            depressed
            @click="mobileView = 'list'"
          >
            <v-icon left small>mdi-format-list-bulleted</v-icon>
            Daftar Lokasi
          </v-btn>
          <v-btn
            class="switch-btn"
            :class="{ 'switch-btn-active': mobileView === 'map' }"
            depressed
            :disabled="!activeItem"
            @click="mobileView = 'map'"
          >
            <v-icon left small>mdi-map</v-icon>
            Lihat Peta
          </v-btn>
        </div>

        <v-row>
          <v-col
            cols="12"
            lg="4"
            class="pa-2"
            v-show="!isMobile || mobileView === 'list'"
          >
            <v-card class="info-summary-card mb-4 pa-4 overflow-hidden">
              <div class="d-flex align-center">
                <v-avatar
                  color="rgba(1, 140, 116, 0.2)"
                  size="45"
                  class="mr-4 border-primary"
                >
                  <v-icon color="#018c74">mdi-traffic-light</v-icon>
                </v-avatar>
                <div>
                  <div class="gold--text text-overline">Jumlah Lokasi</div>
                  <div class="black--text text-h6 font-weight-black">
                    {{ rekayasaList.length }} Titik Pengalihan
                  </div>
                </div>
              </div>
            </v-card>

            <div class="list-control-panel">
              <div class="d-flex align-center mb-3 px-2">
                <div class="line-decorator-gold mr-3"></div>
                <h2 class="black--text text-overline letter-spacing-2">
                  Daftar Lokasi Pengalihan
                </h2>
              </div>

              <div v-if="!rekayasaList.length" class="empty-state pa-6 text-center">
                <v-icon size="40" color="rgba(1, 140, 116, 0.4)" class="mb-2">
                  mdi-map-marker-off-outline
                </v-icon>
                <div class="black--text text-body-2">
                  Belum ada informasi pengalihan arus saat ini.
                </div>
              </div>

              <div class="table-body-container" v-else>
                <div
                  v-for="item in rekayasaList"
                  :key="item.id"
                  class="table-row-wrapper"
                >
                  <v-card
                    class="tenant-row-card"
                    :class="{ 'active-row': activeItem && activeItem.id === item.id }"
                    flat
                    tile
                    @click="setActiveItem(item)"
                  >
                    <v-row no-gutters align="center" class="pa-3">
                      <v-col cols="auto">
                        <div class="icon-hexagon-small">
                          <v-icon small :color="item.status === 1 ? '#ff5252' : '#018c74'"
                            >mdi-map-marker-path</v-icon
                          >
                        </div>
                      </v-col>
                      <v-col class="px-4">
                        <div
                          class="black--text font-weight-black text-subtitle-2 uppercase text-truncate"
                        >
                          {{ item.judul }}
                        </div>
                        <div
                          class="gold--text opacity-6 text-truncate"
                          style="font-size: 0.7rem; letter-spacing: 0.5px"
                        >
                          {{ item.keterangan }}
                        </div>
                      </v-col>
                      <v-col cols="auto">
                        <v-icon small color="#018c74" class="opacity-5"
                          >mdi-chevron-right</v-icon
                        >
                      </v-col>
                    </v-row>
                    <div class="row-hover-effect"></div>
                  </v-card>
                </div>
              </div>
            </div>
          </v-col>

          <v-col cols="12" lg="8" class="pa-2" v-show="!isMobile || mobileView === 'map'">
            <v-card class="map-cyber-panel">
              <div class="map-ui-frame">
                <div class="frame-edge top-left"></div>
                <div class="frame-edge top-right"></div>
                <div class="frame-edge bottom-left"></div>
                <div class="frame-edge bottom-right"></div>
              </div>

              <transition name="fade" mode="out-in">
                <div
                  v-if="activeItem"
                  :key="activeItem.id"
                  class="detail-container-full pa-0"
                >
                  <div class="header-info-overlay pa-6">
                    <v-btn
                      v-if="isMobile"
                      icon
                      small
                      class="back-to-list-btn"
                      @click="mobileView = 'list'"
                    >
                      <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <div
                      class="text-h4 font-weight-black black--text mb-1 letter-spacing-1 detail-title"
                    >
                      {{ activeItem.judul.toUpperCase() }}
                    </div>
                    <div class="gold--text text-caption letter-spacing-2">
                      Sedang berlaku &middot; lokasi sudah ditampilkan di peta
                    </div>
                  </div>

                  <div class="cyber-map-wrapper">
                    <div id="map-traffic-view" class="cyber-map-container"></div>

                    <div class="hud-overlay hud-top-left pa-4">
                      <div class="hud-label gold--text">
                        <v-icon x-small color="#CFA22D">mdi-alert-octagon</v-icon>
                        Penyebab Pengalihan
                      </div>
                      <div class="hud-value black--text">{{ activeItem.keterangan }}</div>
                    </div>

                    <div class="hud-overlay hud-bottom-left pa-4">
                      <div class="hud-label teal--text">
                        <v-icon x-small color="#018c74">mdi-directions-fork</v-icon>
                        Rute Alternatif
                      </div>
                      <div class="hud-value black--text">
                        {{ activeItem.rute_alternatif_desc }}
                      </div>
                    </div>

                    <div class="map-legend">
                      <div class="legend-item">
                        <span class="dot red"></span> Jalan Ditutup
                      </div>
                      <div class="legend-item">
                        <span class="dot teal"></span> Rute Alternatif
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-else
                  class="fill-height d-flex align-center justify-center flex-column pa-10 text-center"
                >
                  <v-icon size="80" color="rgba(1, 140, 116, 0.3)" class="mb-4"
                    >mdi-map-search-outline</v-icon
                  >
                  <div class="gold--text letter-spacing-2 text-overline">
                    Silakan Pilih Lokasi
                  </div>
                  <div class="black--text text-h6 font-weight-bold">
                    Pilih salah satu titik pengalihan pada daftar di samping untuk melihat
                    detail peta
                  </div>
                </div>
              </transition>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { getPengalihanJalan } from "@/api/androidInitApi";

export default {
  data: () => ({
    rekayasaList: [],
    activeItem: null,
    map: null,
    layerClosed: null,
    layerAlt: null,
    altInterval: null,
    particles: [],
    ctx: null,
    animationId: null,
    mobileView: "list",
    windowWidth: typeof window !== "undefined" ? window.innerWidth : 1280,
  }),

  computed: {
    isMobile() {
      return this.windowWidth < 1264;
    },
  },

  async mounted() {
    this.initParticles();
    window.addEventListener("resize", this.handleResize);
    await this.fetchData();
  },

  beforeDestroy() {
    cancelAnimationFrame(this.animationId);
    window.removeEventListener("resize", this.handleResize);
    if (this.altInterval) clearInterval(this.altInterval);
  },

  methods: {
    async fetchData() {
      try {
        this.rekayasaList = (await getPengalihanJalan()) || [];

        if (this.rekayasaList.length > 0) {
          this.setActiveItem(this.rekayasaList[0], { keepListOnMobile: true });
        }
      } catch (e) {
        console.error("API Error", e);
      }
    },

    setActiveItem(item, options = {}) {
      this.activeItem = item;
      if (this.isMobile && !options.keepListOnMobile) {
        this.mobileView = "map";
      }
      setTimeout(() => {
        this.initMap();
        this.renderRoutes();
      }, 100);
    },

    handleResize() {
      this.windowWidth = window.innerWidth;
      this.resizeCanvas();
      if (this.map) {
        setTimeout(() => this.map.invalidateSize(), 200);
      }
    },

    initMap() {
      if (this.map) {
        this.map.remove();
        this.map = null;
      }
      const container = document.getElementById("map-traffic-view");
      if (!container) return;

      this.map = L.map("map-traffic-view", { zoomControl: false }).setView(
        [-7.92719463272193, 113.8350718338104],
        15
      );
      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
      }).addTo(this.map);

      setTimeout(() => this.map && this.map.invalidateSize(), 150);
    },

    renderRoutes() {
      if (!this.map || !this.activeItem) return;
      const closedCoords = JSON.parse(this.activeItem.coords_closed || "[]");
      const altCoords = JSON.parse(this.activeItem.coords_alt || "[]");

      if (closedCoords.length > 0) {
        this.layerClosed = L.polyline(closedCoords, {
          color: "#ff5252",
          weight: 8,
          dashArray: "10, 15",
          opacity: 0.8,
        }).addTo(this.map);
        this.map.fitBounds(this.layerClosed.getBounds(), {
          padding: [40, 40],
          maxZoom: 18,
        });
      }

      if (altCoords.length > 0) {
        this.layerAlt = L.polyline(altCoords, {
          color: "#018c74",
          weight: 6,
          dashArray: "1, 15",
          opacity: 1,
        }).addTo(this.map);
        this.animateAlt();
      }
    },

    animateAlt() {
      let offset = 0;
      if (this.altInterval) clearInterval(this.altInterval);
      this.altInterval = setInterval(() => {
        offset++;
        if (this.layerAlt) this.layerAlt.setStyle({ dashOffset: -offset });
      }, 50);
    },

    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      this.ctx = canvas.getContext("2d");
      this.resizeCanvas();
      this.particles = Array.from({ length: 40 }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        vx: (Math.random() - 0.5) * 0.2,
        vy: (Math.random() - 0.5) * 0.2,
        radius: Math.random() * 1.5 + 0.5,
      }));
      this.animate();
    },
    resizeCanvas() {
      const canvas = this.$refs.particleCanvas;
      if (canvas) {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      }
    },
    animate() {
      if (!this.ctx) return;
      this.ctx.clearRect(
        0,
        0,
        this.$refs.particleCanvas.width,
        this.$refs.particleCanvas.height
      );
      this.particles.forEach((p) => {
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0 || p.x > this.$refs.particleCanvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > this.$refs.particleCanvas.height) p.vy *= -1;
        this.ctx.beginPath();
        this.ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
        this.ctx.fillStyle = "rgba(1, 140, 116, 0.2)";
        this.ctx.fill();
      });
      this.animationId = requestAnimationFrame(this.animate);
    },
  },
};
</script>

<style scoped>
:root {
  --bg-teal: #018c74;
  --bg-teal-dark: #016b62;
  --bg-teal-light: #8bcdc6;
  --bone-white: #f5f5f5;
  --bone-light: #fafafa;
  --text-primary: #2e2e2e;
  --accent-gold: #ffa726;
  --accent-teal: #018c74;
}

.futuristic-app {
  background: #f6f9f9 !important;
  overflow: hidden;
}
.v-application--wrap {
  background: transparent !important;
}
.v-main {
  background: transparent !important;
}

.uppercase {
  text-transform: uppercase;
}
.letter-spacing-2 {
  letter-spacing: 2px !important;
}

.mobile-view-switch {
  display: flex;
  gap: 8px;
  padding: 0 8px;
}
.switch-btn {
  flex: 1;
  background: #fafafa !important;
  color: var(--text-primary) !important;
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
}
.switch-btn-active {
  background: var(--accent-teal) !important;
  color: #fff !important;
  border-color: var(--accent-teal) !important;
}

.back-to-list-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(255, 255, 255, 0.85) !important;
}

.info-summary-card {
  background: #fafafa !important;
  border: 1px solid rgba(45, 138, 122, 0.25) !important;
  border-radius: 16px !important;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}
.map-cyber-panel {
  height: calc(100vh - 160px) !important;
  background: #fafafa !important;
  border-radius: 24px !important;
  border: 1px solid rgba(45, 138, 122, 0.3) !important;
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.empty-state {
  background: #fafafa;
  border-radius: 16px;
  border: 1px solid rgba(45, 138, 122, 0.2);
}
.table-body-container {
  height: calc(100vh - 350px);
  overflow-y: auto;
  border-radius: 16px;
  background: #fafafa !important;
  border: 1px solid rgba(45, 138, 122, 0.2);
  -webkit-overflow-scrolling: touch;
}
.tenant-row-card {
  background: transparent !important;
  cursor: pointer;
  border-bottom: 1px solid rgba(45, 138, 122, 0.12) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--text-primary) !important;
  min-height: 64px;
}
.active-row {
  background: rgba(45, 138, 122, 0.15) !important;
}
.row-hover-effect {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, var(--accent-teal), var(--accent-gold));
  opacity: 0;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 0 2px 2px 0;
}
.tenant-row-card:hover .row-hover-effect,
.active-row .row-hover-effect {
  opacity: 1;
}

.cyber-map-wrapper {
  position: relative;
  height: calc(100vh - 160px);
  width: 100%;
}
.cyber-map-container {
  height: 100%;
  width: 100%;
}
.header-info-overlay {
  position: relative;
}

.hud-overlay {
  position: absolute;
  z-index: 1000;
  background: #fafafa;
  backdrop-filter: blur(15px);
  border: 1px solid rgba(45, 138, 122, 0.3);
  max-width: 250px;
  border-radius: 8px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
  color: var(--text-primary) !important;
}
.hud-top-left {
  top: 100px;
  left: 20px;
  border-left: 4px solid var(--accent-gold);
}
.hud-bottom-left {
  bottom: 20px;
  left: 20px;
  border-left: 4px solid var(--accent-teal);
}

.hud-label {
  font-size: 0.65rem;
  font-weight: 900;
  letter-spacing: 2px;
  margin-bottom: 4px;
  color: var(--accent-teal);
}
.hud-value {
  font-size: 0.8rem;
  line-height: 1.4;
  opacity: 0.95;
  font-weight: 600;
}

.map-legend {
  position: absolute;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  background: #fafafa;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1px solid rgba(45, 138, 122, 0.3);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}
.legend-item {
  font-size: 10px;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  margin: 6px 0;
  letter-spacing: 1px;
  font-weight: 600;
}
.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}
.dot.red {
  background: #ff5252;
  box-shadow: 0 0 8px rgba(255, 82, 82, 0.6);
}
.dot.teal {
  background: var(--accent-teal);
  box-shadow: 0 0 8px rgba(38, 166, 154, 0.6);
}

.map-ui-frame .frame-edge {
  position: absolute;
  width: 15px;
  height: 15px;
  border: 2px solid var(--accent-teal);
  z-index: 1010;
  pointer-events: none;
}
.top-left {
  top: 15px;
  left: 15px;
  border-right: none;
  border-bottom: none;
}
.top-right {
  top: 15px;
  right: 15px;
  border-left: none;
  border-bottom: none;
}
.bottom-left {
  bottom: 15px;
  left: 15px;
  border-right: none;
  border-top: none;
}
.bottom-right {
  bottom: 15px;
  right: 15px;
  border-left: none;
  border-top: none;
}

.gold--text {
  color: var(--accent-gold) !important;
}
.teal--text {
  color: var(--accent-teal) !important;
}

@media (max-width: 1263px) {
  .map-cyber-panel {
    height: calc(100vh - 260px) !important;
  }
  .cyber-map-wrapper {
    height: calc(100vh - 260px);
  }
  .table-body-container {
    height: calc(100vh - 420px);
  }}

@media (max-width: 600px) {

  .mobile-view-switch {
    padding: 0 4px;
  }
  .switch-btn {
    font-size: 0.75rem !important;
    height: 38px !important;
  }

  .info-summary-card {
    margin-bottom: 12px;
  }

  .table-body-container {
    height: calc(100vh - 400px);
    min-height: 260px;
  }

  .map-cyber-panel {
    height: calc(100vh - 230px) !important;
    border-radius: 16px !important;
  }
  .cyber-map-wrapper {
    height: calc(100vh - 230px);
  }

  .header-info-overlay {
    padding: 16px !important;
  }
  .detail-title {
    font-size: 1.25rem !important;
    padding-right: 40px;
  }

  .hud-overlay {
    max-width: 62vw;
    padding: 10px !important;
  }
  .hud-top-left {
    top: auto;
    bottom: 90px;
    left: 10px;
  }
  .hud-bottom-left {
    bottom: 10px;
    left: 10px;
  }
  .hud-label {
    font-size: 0.55rem;
  }
  .hud-value {
    font-size: 0.7rem;
  }

  .map-legend {
    bottom: 10px;
    right: 10px;
    padding: 8px 10px;
  }
  .legend-item {
    font-size: 8px;
    margin: 3px 0;
  }}


.futuristic-app {
  background: #f6f9f9 !important;
}

.main-area {
  background: radial-gradient(circle at 90% 5%, rgba(1, 140, 116, 0.035), transparent 25%),
    #f6f9f9;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;

  backdrop-filter: blur(18px);

  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;

  z-index: 100 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;

  margin: 0 auto;

  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;

  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 12px;

  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);

  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;

  border-radius: 10px;

  background: #f1faf8;

  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;

  font-size: 10px;
  color: #929da1;
  margin-top: 1px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search {
  max-width: 300px;
}

.header-search-wrap {
  min-width: 0;
}

.header-search ::v-deep .v-input__slot,
.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;

  background: #f1f6f5 !important;

  border: 1px solid rgba(1, 140, 116, 0.12) !important;

  box-shadow: none !important;

  transition: all 0.25s ease;
}

.header-search ::v-deep .v-input__slot:focus-within,
.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;

  border-color: #018c74 !important;
}

.header-search ::v-deep .v-icon,
.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

@media (max-width: 600px) {
  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }
}
</style>
